<template>
  <div class="filter">
    <component
      :is="componentType"
      v-model="selected"
      :label="label"
      :options="options"
      :placeholder="placeholder"
      :show-reset="showReset"
      :show-selections="showSelections"
    />
  </div>
</template>

<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    modelValue?: string[]
    label?: string
    placeholder?: string
    showSelections?: boolean
    isMultiSelect?: boolean
  }>(),
  {
    modelValue: () => [],
    label: 'I am in...',
    placeholder: 'Any State or Territory',
    showSelections: true,
    isMultiSelect: true,
  },
)
const emit = defineEmits(['update:modelValue'])
const { fetchStates } = useStoryblokDataSources()
const { data: states } = await fetchStates()
const selected = computed({
  get: () => {
    return props.modelValue
  },
  set: (value) => {
    emit('update:modelValue', value)
  },
})
const componentType = computed(() =>
  getFormkitSelectComponentName(props.isMultiSelect),
)

const options = computed(() =>
  states.value.map((option) => ({
    label: option.name,
    value: option.value,
  })),
)

const showReset = computed(() => props.isMultiSelect)
</script>
